var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1850_56795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.75 30 0 23.25 0 15C0 6.75 6.75 0 15 0C23.25 0 30 6.75 30 15C30 23.25 23.25 30 15 30ZM15 2.5C8.125 2.5 2.5 8.125 2.5 15C2.5 21.875 8.125 27.5 15 27.5C21.875 27.5 27.5 21.875 27.5 15C27.5 8.125 21.875 2.5 15 2.5Z",
    fill: "#585F71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 19.9998C14.2502 19.9998 13.7502 19.4998 13.7502 18.7498V17.8748C13.7502 15.9998 14.7502 14.3748 16.2502 13.4998C17.2502 12.9998 17.7502 11.8748 17.5002 10.8748C17.3752 9.8748 16.5002 8.9998 15.5002 8.8748C14.7502 8.7498 14.0002 8.8748 13.3752 9.3748C12.8752 9.7498 12.5002 10.4998 12.5002 11.2498C12.5002 11.9998 12.0002 12.4998 11.2502 12.4998C10.5002 12.4998 10.0002 11.9998 10.0002 11.2498C10.0002 9.7498 10.6252 8.3748 11.7502 7.3748C12.8752 6.3748 14.3752 5.9998 15.8752 6.2498C17.8752 6.6248 19.5002 8.2498 19.8752 10.2498C20.2502 12.3748 19.2502 14.4998 17.3752 15.4998C16.6252 15.8748 16.2502 16.7498 16.2502 17.7498V18.7498C16.2502 19.4998 15.7502 19.9998 15.0002 19.9998V19.9998Z",
    fill: "#585F71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 23.7499C15.6906 23.7499 16.2502 23.1902 16.2502 22.4999C16.2502 21.8095 15.6906 21.2499 15.0002 21.2499C14.3099 21.2499 13.7502 21.8095 13.7502 22.4999C13.7502 23.1902 14.3099 23.7499 15.0002 23.7499Z",
    fill: "#585F71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 24.375C14 24.375 13.125 23.5 13.125 22.5C13.125 21.5 14 20.625 15 20.625C16 20.625 16.875 21.5 16.875 22.5C16.875 23.5 16 24.375 15 24.375ZM15 21.875C14.625 21.875 14.375 22.125 14.375 22.5C14.375 22.875 14.625 23.125 15 23.125C15.375 23.125 15.625 22.875 15.625 22.5C15.625 22.125 15.375 21.875 15 21.875Z",
    fill: "#585F71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1850_56795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9e53967e.svg";
export { ForwardRef as ReactComponent };